export type GridArrowKey = 'ArrowUp' | 'ArrowDown' | 'ArrowLeft' | 'ArrowRight';

export function moveGridSelection(
  index: number,
  key: GridArrowKey,
  rows: number,
  columns: number,
): number {
  const row = Math.floor(index / columns);
  const column = index % columns;
  if (key === 'ArrowUp') return Math.max(0, row - 1) * columns + column;
  if (key === 'ArrowDown') return Math.min(rows - 1, row + 1) * columns + column;
  if (key === 'ArrowLeft') return row * columns + Math.max(0, column - 1);
  return row * columns + Math.min(columns - 1, column + 1);
}

export function isGridArrowKey(key: string): key is GridArrowKey {
  return ['ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight'].includes(key);
}
